import { Reveal } from "@/components/common/Reveal";

export const PageHeader = ({ eyebrow, title, subtitle, image, tone = "default" }) => (
  <section className={`relative overflow-hidden ${tone === "calm" ? "bg-white" : ""}`}>
    <div
      className="absolute inset-0 -z-10"
      style={{
        background:
          "radial-gradient(1200px 500px at 15% 0%, rgba(15,92,90,0.12), transparent 60%), radial-gradient(900px 450px at 90% 0%, rgba(200,168,107,0.10), transparent 55%)",
      }}
    />
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-12 lg:pt-24 lg:pb-16">
      <div className={`grid ${image ? "lg:grid-cols-2 gap-10 items-center" : ""}`}>
        <Reveal>
          {eyebrow && <span className="inline-block text-xs font-semibold uppercase tracking-[0.18em] text-[var(--cdt-accent)]">{eyebrow}</span>}
          <h1 className="font-display text-4xl md:text-5xl lg:text-[3.4rem] leading-[1.06] tracking-[-0.02em] text-[var(--cdt-text)] mt-3">{title}</h1>
          {subtitle && <p className="mt-5 text-lg leading-8 text-[var(--cdt-muted)] max-w-xl">{subtitle}</p>}
        </Reveal>
        {image && (
          <Reveal delay={0.1}>
            <div className="rounded-[var(--cdt-radius-lg)] overflow-hidden shadow-[var(--cdt-shadow-lg)]">
              <img src={image} alt={title} loading="lazy" className="w-full h-[300px] lg:h-[380px] object-cover" />
            </div>
          </Reveal>
        )}
      </div>
    </div>
  </section>
);
